import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-search-filter',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './search-filter.component.html'
})
export class SearchFilterComponent {
  @Input() searchTerm: string = '';

  @Output() searchChanged = new EventEmitter<string>();

  onSearchChange(event: Event) {
    this.searchChanged.emit((event.target as HTMLInputElement).value);
  }

  clearSearch() {
    this.searchChanged.emit('');
  }
}
